// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"07e62b06","63":"4fb3d80b","95":"644a6ea5","334":"cb4f476d","565":"0b080b55","936":"52352c3f","963":"dd325bbc","972":"2285f93f"}[chunkId] + ".chunk.js";
};